import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, UrlTree} from '@angular/router';
import {AuthService} from "../_services/auth.service";
import {NotificationService} from "../_services/notification.service";
import {SnackbarService} from "../_services/snackbar.service";
import {LocalStorageService} from "../_services/local-storage.service";
import {ContentService} from "../_services/content.service";
import {CommunitiesService} from "../_services/communities.service";

@Component({
    selector: 'app-passthrough',
    templateUrl: './passthrough.component.html',
    styleUrls: ['./passthrough.component.scss']
})
export class PassthroughComponent implements OnInit {

    constructor(private route: ActivatedRoute,
                private readonly router: Router,
                private authService: AuthService,
                private notificationService: NotificationService,
                private readonly snack: SnackbarService,
                private readonly localStorageService: LocalStorageService,
                private contentService: ContentService,
                private readonly communitiesService: CommunitiesService,
    ) {
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe((params): void => {
                if (params['app']) {
                    this.localStorageService.setItem(true, 'isApp')
                } else {
                    this.localStorageService.removeItem('isApp')
                }

                if (params['token']) {
                    // Pass token to hijack the user
                    this.authService.setUserWithToken(params['token'], params['hijack']).then((): void => {
                        let returnUrl: string | null = this.validateReturnUrl(decodeURIComponent(params['returnUrl']))
                        this.communitiesService.getUserCommunities(params['token']).subscribe(res => {
                            this.contentService.setCurrentDashboardCommunity(res[0].community)
                            if (params['notification']) {
                                this.notificationRouting(params)
                            } else if (params['returnUrl'] && returnUrl) {
                                this.router.navigateByUrl(returnUrl)
                            } else {
                                this.router.navigate(['/dashboard']);
                            }
                        })
                    }).catch((err): void => {
                        this.authService.logout();
                    });
                } else if (params['notification']) {
                    this.notificationRouting(params)
                } else {
                    console.error('No useful params why are you here?');
                    this.authService.logout();
                }
            }
        );
    }

    notificationRouting(params: any): void {
        if (this.authService.isLoggedIn()) {
            // if the user is logged in then get notification and re-direct
            let returnUrl: string | null = this.validateReturnUrl(decodeURIComponent(params['returnUrl']))
            this.notificationService.getNotification(params['notification']).subscribe(r => {
                if (params['returnUrl'] && returnUrl) {
                    this.router.navigateByUrl(returnUrl).then((): void => {
                        this.notificationService.notificationRedirect(r)
                    });
                } else {
                    this.router.navigate(['/dashboard']).then((): void => {
                        this.notificationService.notificationRedirect(r)
                    });
                }
            }, e => {
                this.snack.openErrorSnackBar(e)
                this.router.navigate(['/dashboard'])
            })

        } else {
            // if the user is not logged in then get them to return here when they are
            this.authService.logout(window.location.pathname + window.location.search);
        }
    }

    validateReturnUrl(url: string): string | null {
        const validPathRegex = /^[a-zA-Z0-9\-._~\/]*$/;
        // Check if the URL matches the valid path pattern
        if (url != undefined && url && validPathRegex.test(url) && !url.includes('404')) {
            try {
                const urlTree: UrlTree = this.router.parseUrl(url);
                // If parseUrl doesn't throw an error, the URL is considered valid
                return url;
            } catch (e) {
                console.warn('Invalid URL:', url);
                // Handle invalid URL scenario
                return null;
            }
        } else {
            return null
        }
    }

}
